import { FormField } from '@dixa/lib-shared-habla';
import { HookFormText } from 'lib-shared-hook-form';

import { OAuthStrategySchemaField } from 'apis/partnerIntegrations/oAuth/types/partnerIntegrationsOAuth.types';

import type { OAuthProviderConfigurationMode } from '../../oauthProviderConfigurationModal.types';
import { OAuthProviderConfigurationSchemaField } from '../schemaField/oauthProviderConfigurationSchemaField';

type OAuthProviderSettingsConfigurationProps = {
  mode: OAuthProviderConfigurationMode;
  schema: readonly OAuthStrategySchemaField[];
};

/**
 * A component for rendering the settings configuration form of an OAuth
 * provider.
 *
 * @param mode - The mode of the form.
 * @param schema - The configuration schema of the OAuth strategy.
 * @returns The form fields for the OAuth provider settings configuration.
 */
export const OAuthProviderSettingsConfiguration = ({
  mode,
  schema,
}: OAuthProviderSettingsConfigurationProps): JSX.Element => {
  const isCreateMode = mode === 'create';

  return (
    <>
      <FormField>
        <HookFormText
          label="Name"
          name="name.value"
          rules={{
            required: 'The name is required',
          }}
          componentProps={{
            placeholder: 'Enter a name for your OAuth provider',
          }}
        />
      </FormField>

      {schema.map((field) => (
        <FormField key={field.key}>
          <OAuthProviderConfigurationSchemaField
            isCreateMode={isCreateMode}
            field={field}
          />
        </FormField>
      ))}
    </>
  );
};
